/**
 * console_enabled=false 계정이 로그인 시도 시 안내 화면.
 * 토큰은 저장 안 함 — 흔적 0.
 */
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export function AccessDeniedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-alt p-6">
      <div className="w-full max-w-sm bg-surface border border-bdr-subtlest rounded-xl p-7 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-4">
          <ShieldOff className="w-6 h-6 text-destructive" />
        </div>
        <h1 className="text-base font-bold mb-2">설정콘솔 접근 권한이 없습니다</h1>
        <p className="text-xs text-fg-subtler leading-relaxed">
          ATGRD가 발급한 console 접근 권한이 필요합니다.
          <br />
          가맹점·점주 화면(주문/매출)은 dashboard에서 그대로 사용 가능합니다.
        </p>

        <div className="mt-6 space-y-2">
          <a
            href="mailto:purchase@autogeared.com"
            className="block w-full px-4 py-2 rounded-md text-sm font-semibold bg-fg text-surface hover:bg-fg/90"
          >
            ATGRD에 문의
          </a>
          <Link
            to="/login"
            className="block w-full px-4 py-2 rounded-md text-sm border border-bdr-subtle hover:bg-surface-alt"
          >
            다른 계정으로 로그인
          </Link>
        </div>
      </div>
    </div>
  );
}
